import React from 'react';

const LetsWorkTogether = () => {
    return(
        <section className="lead">
            <div className="container mx-auto px-4 text-center">
                <div className="flex items-center justify-center">
                    <div className="w-full">
                        <div className="lead-title text-white mb-5 mt-4">
                            <h4 className="title-font">
                            Let's build the future together
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default LetsWorkTogether
